import { ref, readonly } from 'vue'

export const useIsOnline = (initial) => {
  const state = ref(structuredClone(initial))

  const set = (value) => {
    state.value = value
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = ''
  }

  return { isOnline: readonly(state), set, reset, clear }
}